import React from "react";
import styled, { keyframes } from "styled-components";

import ImgCurrency from "../../Assets/frontendImages/global currency.svg";
import ImgTime from "../../Assets/frontendImages/time tracking 5.svg";
import ImgMeeting from "../../Assets/frontendImages/booking.svg";
import ImgInvoice from "../../Assets/frontendImages/invoices.svg";
import ImgTask from "../../Assets/frontendImages/task progress.svg";
import ImgProject from "../../Assets/frontendImages/project client.svg";

const slideLeft = keyframes`from { opacity: 0; transform: translate(-80px, 0); } to { opacity: 1; transform: translate(0, 0); }`;
const slideTop = keyframes`from { opacity: 0; transform: translate(0, -80px); } to { opacity: 1; transform: translate(0, 0); }`;
const slideBottom = keyframes`from { opacity: 0; transform: translate(0, 80px); } to { opacity: 1; transform: translate(0, 0); }`;
const slideRight = keyframes`from { opacity: 0; transform: translate(80px, 0); } to { opacity: 1; transform: translate(0, 0); }`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto 18rem;
  justify-content: center;
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  @media (max-width: 600px) {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    gap: 0px !important;
    padding: 0 10px !important;
  }
`;

const StyledImage = styled.img`
  display: block;
  width: 100%;
  animation-duration: 1.2s;
  animation-fill-mode: both;
  animation-name: ${(props) => props.$animation};

  @media (max-width: 1200px) {
    &.mobile-hidden {
      display: none !important;
    }
  }

  @media (min-width: 600px) and (max-width: 1200px) {
    &.mobile-img-1,
    &.mobile-img-2 {
      display: none;
    }
  }

  @media (max-width: 600px) {
    &.mobile-img-1 {
      width: 85% !important;
      z-index: 1;
      margin-right: 30px;
    }

    &.mobile-img-2 {
      width: 78% !important;
      z-index: 2;
      margin-top: -90px !important;
      margin-left: 70px;
      box-shadow: -6px -4px 7px 2px rgba(0, 0, 0, 0.1);
      border-radius: 22px;
    }
  }
`;

function LandingHeroImages() {
  return (
    <GridWrapper className="hero-grid">
      <StyledImage src={ImgCurrency} alt="1" className="mobile-img-1" $animation={slideLeft} />

      <StyledImage src={ImgTime} alt="2" className="mobile-hidden" $animation={slideTop} />

      <StyledImage src={ImgMeeting} alt="3" className="mobile-hidden" $animation={slideRight} />

      <StyledImage src={ImgInvoice} alt="4" className="mobile-img-2" $animation={slideLeft} style={{ marginTop: "-40px" }} />

      <StyledImage src={ImgTask} alt="5" className="mobile-hidden" $animation={slideBottom} style={{ marginTop: "-40px" }} />

      <StyledImage src={ImgProject} alt="6" className="mobile-hidden" $animation={slideRight} />
    </GridWrapper>
  );
}

export default LandingHeroImages;
